import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home";
import DocumentDetail from "../views/DocumentDetail";
import Context from "../views/Context";

Vue.use(Router);

export default new Router({
  //mode: 'abstract',
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/context",
      name: "context",
      component: Context
    },
    {
      path: "/document/:id",
      name: "document.detail",
      component: DocumentDetail
    }
  ]
});
